import styled from 'styled-components'

export const PauseIndicator = styled.div<{ visibility: boolean }>`
  font-size: 0.8rem;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['200'] || '74, 74, 74'})` : '#999'};
  margin: 0.5em 0;
  text-align: center;
  font-weight: 500;
  visibility: ${({ visibility }) => (visibility ? 'visible' : 'hidden')};
`
